import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  DiagnosticIssue,
  SingleIssueItem,
} from 'types/Memory/MemoryDiagnostics';
import { InfoCard, SparkImageLoader } from 'sharedComponents/UI';
import FieldSkeleton from 'sharedComponents/Skeleton/FieldSkeleton';

const StatusItem = ({
  childIssues,
  setSelectedNavListItemID = () => {},
}: {
  childIssues: SingleIssueItem[];
  setSelectedNavListItemID: (id: number) => void;
}) => {
  const handleStatusClick = (type: string, id: string) => {
    setSelectedNavListItemID(1);
  };
  return (
    <Box display='flex' flexDirection='column' gap={2}>
      {childIssues.map((childIssue, index) => (
        <Box
          component='div'
          key={`${childIssue.title}_${index}`}
          onClick={() => handleStatusClick(childIssue.type, childIssue.id)}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: 2,
            borderRadius: '10px',
            transition: 'transform 0.1s',
            border: (theme) => `1px solid ${theme.palette.borderColor}`,
            '&:hover': {
              borderColor: (theme) => theme.palette.primary.main,
              cursor: 'pointer',
            },
          }}
        >
          <Box display='flex' gap={1} alignItems='center'>
            <Box>
              <SparkImageLoader
                src={childIssue.iconURL || ''}
                alt={childIssue.iconURL || ''}
              />
            </Box>
            <Typography
              sx={{
                display: '-webkit-box',
                color: '#4A4A4A',
                lineHeight: '24px',
                textWrap: 'wrap',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
              }}
            >
              {childIssue.title}
            </Typography>
          </Box>
          <Box marginLeft={4}>
            <Typography
              sx={{
                display: '-webkit-box',
                color: '#4A4A4A',
                fontSize: '14px',
                fontStyle: 'normal',
                lineHeight: '24px',
                textWrap: 'wrap',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
              }}
            >
              {childIssue.detail}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

type MemoryStatusesProps = {
  issues: DiagnosticIssue[] | undefined;
  isMemoryDiagnosticsLoading: boolean;
  setSelectedNavListItemID: (id: number) => void;
};

function MemoryStatuses({
  issues,
  isMemoryDiagnosticsLoading,
  setSelectedNavListItemID,
}: MemoryStatusesProps) {
  return (
    <Box display='flex' gap={2} flexDirection='column' width='100%'>
      {isMemoryDiagnosticsLoading && <FieldSkeleton count={6} />}
      {!issues?.length && !isMemoryDiagnosticsLoading && (
        <InfoCard
          info='This Knowledge Source has no issues'
          type='success'
          cardStyles={{ height: 'auto !important' }}
        />
      )}
      {issues?.map((issue, index) => (
        <Box
          display='flex'
          flexDirection='column'
          gap={2}
          key={`${issue.title}_${index}`}
        >
          <Typography fontFamily='mont-semibold'>{issue.title}</Typography>
          <StatusItem
            childIssues={issue.issues}
            setSelectedNavListItemID={setSelectedNavListItemID}
          />
        </Box>
      ))}
    </Box>
  );
}

export default MemoryStatuses;
